import React from 'react';
import { ArrowRight, Folder } from 'lucide-react';
import { Project } from '../../utils/types';
import { useTranslation } from 'react-i18next';
import './ProjectCard.css';
import ProjectIcon from '../../tools/project-icon';

interface ProjectCardProps {
  project: Project;
  numOfFilesInProject: number;
  selected: boolean;
  onSelect: (project: Project) => void;
}

export default function ProjectCard({
  project,
  numOfFilesInProject,
  selected,
  onSelect,
}: ProjectCardProps) {
  // translation function
  const { t } = useTranslation();
  return (
    <button
      className={`landing-project-card ${selected ? 'selected' : ''}`}
      aria-pressed={selected}
      onClick={() => onSelect(project)}
    >
      {selected && <div className="landing-project-selected">selected</div>}

      <div className="landing-project-header">
        <div className="landing-project-icon">
          <ProjectIcon project={project} size={50} />
        </div>

        <h3 className="landing-project-name">{project.name.toUpperCase()}</h3>
      </div>

      <div className="landing-project-footer">
        <div className="landing-project-files">
          {selected && (
            <>
              <Folder size={22} />
              <span>{t(`${numOfFilesInProject} file(s)`)}</span>
            </>
          )}
        </div>

        <div className="landing-project-open text-colour">
          <ArrowRight size={22} strokeWidth={1.5} />
        </div>
      </div>
    </button>
  );
}
